export default {
  name: 'wisk-minus',
  width: 35,
  height: 35,
  paths: [{ d: 'M35,17.518a3.141,3.141,0,0,1-3.154,3.153H3.188a3.171,3.171,0,1,1,0-6.342H31.846A3.171,3.171,0,0,1,35,17.518Z' }]
}
